import uniqid from 'uniqid'

const surveys = [
  {
    slug: 'product-usage-1',
    name: 'Product Usage',
    structure: [
      {
        type: 'SINGLE_CHOICE',
        question: 'How often do you use our product?',
        answers: ['daily', 'few times a week', 'once a week', 'once a month'],
        required: true,
      },
      {
        type: 'TEXT_ANSWER',
        question: 'Does the product help you achieve your goals?',
        required: true,
      },
      {
        type: 'TEXT_ANSWER',
        question: 'What would you improve if you could?',
        required: false,
      },
    ].map((field) => ({ ...field, id: uniqid() })),
  },
  {
    slug: 'demographics-1',
    name: 'Demographics',
    structure: [
      {
        type: 'SINGLE_CHOICE',
        question: 'How old are you?',
        answers: [
          'less than 20',
          'between 20 and 30',
          'between 30 and 40',
          'more than 50',
        ],
        required: true,
      },
      {
        type: 'TEXT_ANSWER',
        question: 'What gender do you identify as?',
        required: true,
      },
      {
        type: 'TEXT_ANSWER',
        question: 'What is your employment status?',
        required: false,
      },
    ].map((field) => ({ ...field, id: uniqid() })),
  },
  {
    slug: 'satisfaction-scale-1',
    name: 'Satisfaction Scale',
    structure: [
      {
        type: 'SINGLE_CHOICE',
        question:
          'Which of the following words would you use to describe our product?',
        answers: [
          'Life-saving',
          'Great',
          'Fine, but there are some issues',
          'Buggy',
        ],
        required: true,
      },
      {
        type: 'TEXT_ANSWER',
        question: 'Does the product help you achieve your goals?',
        required: true,
      },
      {
        type: 'TEXT_ANSWER',
        question: 'What would you improve if you could?',
        required: false,
      },
    ].map((field) => ({ ...field, id: uniqid() })),
  },
]

export default surveys
